module.exports = __webpack_public_path__ + "img/home_swiper_03_mobile.331ced6a.jpg";